<template>
    <div class="modelList_box">
        <div class="app_container">
            <div id="list_info" class="modelList_infoShow_max">
                <div id="info_top" class="info_top">
                    <span class="info_title">标记详情：{{ this.decoeList.name }}（{{this.index}}/{{this.showDecorList.length}}）</span>
                    <span class="zoom_window" v-on:click="zoomdiv" href="javascript:;">
                        <img class="zoom_icon" src="../../static/img/最小化.png" alt="shrink"/></span>
                    <span id="close_icon" class="layui-layer-setwin" @click="closediv()">
                        <a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a>
                    </span>
                </div>
                <div id="info_bottom" class="info_bottom_max">
                    <div id="info_left" class="info_left_max">
                        <span class="fullScreenClose" @click="closediv()"></span>
                        <div id="infoShow_div3d" class="show3DdivC_max">
                            <div class="modelDetailLeft" @click="moveModelLeft()">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </div>
                            <div class="modelDetailRight" @click="moveModelRight()">
                                <i class="fa fa-chevron-right" aria-hidden="true"></i>
                            </div>
                            <iframe id="decoriframe" class="myframe" src="https://www.thingjs.com/guide/sampleindex.html?m=295409/PreviewViewDecor.js" frameborder="0" style="width:100%;height:100%;display:none;"></iframe>
                        </div>
                    </div>
                    <div id="info_right" class="info_right_max">
                        <div
                            id="info_shop"
                            class="info_shop"
                            style="'width:216px;word-break: break-all;'"
                        >
                            <div class="shopDetailsBox" style="display: flex;align-items: center;">
                                <div style="height: 14px;width: 3px;background: rgb(255, 149, 75);float: left;margin-right: 6px;"></div>
                                <span style="font-size: 14px; font-weight: bold;">基本信息</span>
                            </div>
                            <div class="shopDetailsBox" v-if="this.decoeList.type == '点'">类型：point
                            </div>
                            <div class="shopDetailsBox" v-if="this.decoeList.type == '数据面板'">类型：dataPanel
                            </div>
                            <div class="shopDetailsBox" v-if="this.decoeList.type == '面'">类型：surface</div>
                            <div class="shopDetailsBox" v-if="this.decoeList.type == '线'">类型：line</div>
                            <div class="shopDetailsBox">
                                上传时间：{{this.decoeList.createTime ? this.decoeList.createTime : "暂无"}}
                            </div>
                            <div class="shopDetailsBox">
                                更新时间：{{ this.decoeList.updateTime ? this.decoeList.updateTime : "暂无"}}
                            </div>
                            <div class="shopDetailsBox">作者：UINO</div>
                            <div class="shopDetailsBox">资源版本：1.0</div>
                            <div class="shopDetailsBox">格式：bundle</div>
                            <div class="shopDetailsBox">
                                标记ID：{{this.decoeList._id ? this.decoeList._id : "暂无"}}
                            </div>
                            <div class="shopDetailsBox">文件大小：暂无</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { postLowCodePlugins } from "../network/thingxApi";
var leftchangeFlag = true;
var rightchangeFlag = true;
export default {
    data() {
        return {
            showDecorList: [],
            param: {
                "pageNumber": 1,
                "pageSize": 9999,
                "typeName": "标记",
                "type": "",
                "resourceName": ""
            },
            index: 1,
            decoeList: {},
            listLength: 0
        };
    },
    props: {
        decorData: {
            type: Object,
            defaule: {}
        }
    },
    beforeMount () {
        var _this = this;
        _this.decoeList = _this.decorData;
        _this.index =_this.decoeList._index;
    },
    mounted() {
        var _this = this;
        $("#preview-decor").css({ height: "auto", "max-height": "100%" });
        $("#preview-decor.content").css("height", "auto");
        _this.decoeList = _this.decorData;
        _this.index =_this.decoeList._index;
        // console.log(_this.decoeList.url,'预览的prelink');
        this.showData(_this.decoeList.url);
        document.onkeydown = function(event){
            if(event.keyCode == 65||event.keyCode == 37){
                if(leftchangeFlag){
                    _this.moveModelLeft();
                }else {
                    return;
                }
            }else if(event.keyCode == 68 || event.keyCode == 39){
                if(rightchangeFlag){
                    _this.moveModelRight();
                }else {
                    return;
                }
            }else{
                return;
            }
        };
    },
    methods: {
        showData(link, type = "init") {
            var _this=this;
            var iframe = document.getElementById("decoriframe");
            $(document).ready(function(e){
                if (iframe.attachEvent) {
                    if (_this.iframeFlag) {
                        iframe.attachEvent("onload", function() {
                            _this.iframeFlag = false;
                            setTimeout(function() {
                                _this.callFuncInThingJS(type, link);
                            }, 1000);
                        });
                    } else {
                        setTimeout(function() {
                            _this.callFuncInThingJS(type, link);
                        }, 1000)
                    }
                } else {
                    if (_this.iframeFlag) {
                        iframe.onload = function() {
                            _this.iframeFlag = false;
                            setTimeout(function() {
                                _this.callFuncInThingJS(type, link);
                            }, 1000);
                        };
                    } else {
                        setTimeout(function() {
                            _this.callFuncInThingJS(type, link);
                        }, 1000)
                    }
                }
            })
        },
        moveModelLeft(){
            leftchangeFlag = false;
            setTimeout(function(){
                leftchangeFlag = true;
            },1000);
            var _this = this;
            var _list = _this.showDecorList;
            var _index = _this.index - 1;
            _this.index = _index;
            if(_index <= 0){
                _this.index = 1;
                _this.$layer.msg("已经是第一个标记了哦！");
                $(".vl-notify.vl-notify-msg").css('left','45%');
                $(".vl-notify.vl-notify-msg").css('index','10000');
            }else{
                if(_list[_index]) {
                    var _model=_list[_index - 1];
                    _this.decoeList = _model;
                    _this.callFuncInThingJS("init",-1);
                    this.showData(_this.decoeList.url);
                }else {
                   var _model=_list[_index - 1];
                    _this.decoeList = _model;
                    _this.callFuncInThingJS("init",-1);
                    this.showData(_this.decoeList.url);
                }
            }
        },
        moveModelRight(){
            rightchangeFlag = false;
            setTimeout(function(){
                rightchangeFlag = true;
            },1000);
            var _this = this;
            var _list = _this.showDecorList;
            var _index = _this.index + 1;
             _this.index = _index;
            if(_index >= _this.listLength){
                _this.index = _this.listLength;
                _this.$layer.msg("已经是最后一个标记了哦！");
                $(".vl-notify.vl-notify-msg").css('left','45%');
                $(".vl-notify.vl-notify-msg").css('index','10000');
            }else{
                if(_list[_index]) {
                    var _model=_list[_index + 1];
                    _this.decoeList = _model;
                    _this.callFuncInThingJS("init",-1);
                    this.showData(_this.decoeList.url);
                }else {
                var _model=_list[_index + 1];
                    _this.decoeList = _model;
                    _this.callFuncInThingJS("init",-1);
                    this.showData(_this.decoeList.url);
                }
            }
        },
        callFuncInThingJS:function(funcName, data) {
            $('#decoriframe').show();
            var iframe = $('#decoriframe')[0];
            var message = {
                'funcName': funcName,// 所要调用ThingJS页面里的函数名
                'param': data
            }
            // if (iframe.contentWindow) iframe.contentWindow.postMessage(message, '*');
            if (iframe.contentWindow) iframe.contentWindow.postMessage({
                'funcName': funcName,// 所要调用ThingJS页面里的函数名
                'param': data
            }, '*');
        },
        zoomdiv() {
            let zoomicon = document.getElementsByClassName("zoom_icon")[0];
            let listInfo = document.getElementById("list_info");
            let infoBottom = document.getElementById("info_bottom");
            let infoLeft = document.getElementById("info_left");
            let infoShowDiv3d = document.getElementById("infoShow_div3d");
            let infoRight = document.getElementById("info_right");
            if ($(".fullScreen").hasClass("tuichu")) {
                -$("#list_info").removeClass("quanping");
                $("#decoriframe").removeClass("fullFrame");
                $(".fullScreen").removeClass("tuichu");
                $(".popContainer").show();
                $(".fullScreenClose").hide();
                if (zoomicon.alt == "maximize") {
                    $(".kefuBtn").show();
                    $(".qqBtn").show();
                    $(".wxBtn").show();
                }
            }
            if (zoomicon.alt == "shrink") {
                listInfo.className = "modelList_infoShow";
                infoBottom.className = "info_bottom";
                infoLeft.className = "info_left";
                infoShowDiv3d.className = "show3DdivC";
                infoRight.className = "info_right";
                $(".kefuBtn").show();
                $(".qqBtn").show();
                $(".wxBtn").show();
                zoomicon.src = "../../static/img/最大化.png";
                zoomicon.alt = "maximize";
            } else if (zoomicon.alt == "maximize") {
                listInfo.className = "modelList_infoShow_max";
                infoBottom.className = "info_bottom_max";
                infoLeft.className = "info_left_max";
                infoShowDiv3d.className = "show3DdivC_max";
                infoRight.className = "info_right_max";
                $(".kefuBtn").hide();
                $(".qqBtn").hide();
                $(".wxBtn").hide();
                zoomicon.src = "../../static/img/最小化.png";
                zoomicon.alt = "shrink";
            }
        },
        closediv() {
            this.$emit("cancel", false);
            document.documentElement.style.cssText = "overflow:initial;";
            document.body.style.cssText = "overflow:initial;padding:0;";
        },
        getDecorList(){
            postLowCodePlugins(this.param).then((res) => {
                this.showDecorList.push(...res.content.list);
                this.listLength = this.showDecorList.length;
            })
        }

    },
    created() {
        this.getDecorList();
    }
};
</script>
<style>
@import "../assets/css/modelList.css";
</style>



// WEBPACK FOOTER //
// src/components/previewDecor.vue